import { AfterViewInit, Directive, ElementRef, EventEmitter, Output, OnDestroy } from '@angular/core'
import { fromEvent, Subscription } from 'rxjs'
import { filter } from 'rxjs/operators'

@Directive({
  selector: '[jmlLibOnEscape]'
})
// listen for Escape Key => especially used for ColorPicker, since it does react to key-press if a hex value was selected with the mouse
export class OnEscapeDirective implements AfterViewInit, OnDestroy {
  @Output() onEscape = new EventEmitter()

  private keyKlickSubscription: Subscription

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const keyKlick$ = fromEvent(document, 'keyup').pipe(filter((e: KeyboardEvent) => e.key === 'Escape'))

    this.keyKlickSubscription = keyKlick$.subscribe((event) => {
      this.onEscape.emit(event)
    })
  }

  ngOnDestroy() {
    this.keyKlickSubscription.unsubscribe()
  }
}
